import { lazyLoad } from "utils/loadable";

export const AdminActivityLogs = lazyLoad(
  () => import("./index"),
  (module) => module.AdminActivityLogs
);
